export const AUTH_TOKEN = 'token'
export const APPLICANT_TOKEN = 'applicant'

export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE'
export const GROUPS_SUCCESS = 'GROUPS_SUCCESS'

export const CITIES_SUCCESS = 'CITIES_SUCCESS'
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST'

export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS'
export const CUSTOMER_REQUEST = 'CUSTOMER_REQUEST'

export const REQUEST_MFA_CODE_REQUEST = 'REQUEST_MFA_CODE_REQUEST'
export const REQUEST_MFA_CODE_SUCCESS = 'REQUEST_MFA_CODE_SUCCESS'
export const REQUEST_MFA_CODE_FAILURE = 'REQUEST_MFA_CODE_FAILURE'

export const SET_USER_CREDS = 'SET_USER_CREDS'
export const DELETE_USER_CREDS = 'DELETE_USER_CREDS'

export const INVALIDATE_ZIPCODE = 'INVALIDATE_ZIPCODE'

export const VERIFY_NUMBER_SUCCESS = 'VERIFY_NUMBER_SUCCESS'

export const SEND_VERIFICATION_ATTEMPT = 'SEND_VERIFICATION_ATTEMPT'
export const SEND_VERIFICATION_SUCCESS = 'SEND_VERIFICATION_SUCCESS'

export const CUSTOMER_CONFIRMED_SUCCESS = 'CUSTOMER_CONFIRMED_SUCCESS'
export const CLEAR_PHONE_VERIFICATION = 'CLEAR_PHONE_VERIFICATION'
export const CLEAR_MARKETS = 'CLEAR_MARKETS'
export const GET_MARKETS_SUCCESS = 'GET_MARKETS_SUCCESS'
export const GET_MARKETS_REQUEST = 'GET_MARKETS_REQUEST'
export const GET_MARKETS_ERROR = 'GET_MARKETS_ERROR'
export const CUSTOMER_RESPONSE_ERROR = 'CUSTOMER_RESPONSE_ERROR'
export const APPLICANT_RESPONSE_ERROR = 'APPLICANT_RESPONSE_ERROR'
export const CUSTOMER_FORM_ERROR = 'CUSTOMER_FORM_ERROR'
export const CLEAR_CUSTOMER_ERROR = 'CLEAR_CUSTOMER_ERROR'
export const CLEAR_APPLICANT_ERROR = 'CLEAR_APPLICANT_ERROR'

export const RESET_STORED_DATA = 'RESET_STORED_DATA'
export const CUSTOMER_PASSWORD_CREATED = 'CUSTOMER_PASSWORD_CREATED'
export const CUSTOMER_APPLY_SUCCESS = 'CUSTOMER_APPLY_SUCCESS'
export const CUSTOMER_APPLY_REQUEST = 'CUSTOMER_APPLY_REQUEST'

export const HYDRATE_APPLICANT = 'HYDRATE_APPLICANT'

export const LOAD_APPS_SUCCESS = 'LOAD_APPS_SUCCESS'
export const LOAD_APPS_REQUEST = 'LOAD_APPS_REQUEST'

export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS'

export const PASSWORD_STRENGTH_SUCCESS = 'PASSWORD_STRENGTH_SUCCESS'
export const PASSWORD_STRENGTH_FAILURE = 'PASSWORD_STRENGTH_FAILURE'
export const PASSWORD_STRENGTH_CLEAR = 'PASSWORD_STRENGTH_CLEAR'

export const ZIP_RADIUS = 25
